<section class="header">
  <div class="container">
    <div class="row header1">
      <div class="col-lg-2 col-2">
        <a routerLink="/flight/flight-search">
          <img [src]="logoFailed ? logoUrl : imageUrl + logoUrl" (error)="onLogoError()" [height]="logoHeight"
            class="py-1" />
        </a>
      </div>
      <div class="col-lg-10 col-10 d-flex justify-content-end align-items-center">
        <div class="top-right-nav text-end d-flex float-right font-weight-400 gap-1">
          <span><a class="cpr" (click)="fullscreen()"><i class="uil-minus-path"></i></a></span> <span
            class="devider">|</span>
          <span class="d-lg-inline-block d-none">
            <a class="cpr px-1" (click)="getAccountAmount()">
              <i class="font-size-12 fa fa-refresh" [ngClass]="isLoadingBal ? 'fa-spin fa-spinner' : ''"></i>
            </a> <strong matTooltip="Aval Bal: {{ avalBal }}/ OD: {{ overDraft }}">Cash Bal:
              <span [ngStyle]="getColor()">{{
                avalBal ? avalBal : "∞"
                }}</span></strong>
            @if(showRechargeButton){
            <span class="devider">|</span>
            <a routerLink="/recharge">Recharge</a>
            }

            <span class="devider">|</span>
          </span>
          <span class="prof-link d-block" (click)="profileIcon = !profileIcon"><span class="d-none d-sm-inline">Welcome :
            </span><span class="text-capitalize">{{ this.userName }}</span>
            @if(billingCode) {&nbsp;<span>[{{billingCode}}]</span>}
            <div class="prof-pop shadow" [ngClass]="{ 'd-block': profileIcon }">
              <ul>
                <li *ngIf="!authArr.includes(userRole)">
                  <a class="d-flex justify-content-between">
                    <i class="fa-solid fa-person-military-to-person"></i> Proxy

                    <mat-slide-toggle [checked]="isProxy" (change)="setProxyStatus($event)"></mat-slide-toggle>
                  </a>
                </li>
                <li>
                  <a routerLink="/profile"><i class="fa-solid fa-user-astronaut"></i> Profile</a>
                </li>
                <li>
                  <a routerLink="/organization-settings"><i class="fa-regular fa-building"></i> Organization
                    Settings</a>
                </li>
                <!-- ETH Pulse (staff) and the support desk, with conversations waiting on a reply. -->
                @if(pulseAccess){
                <li>
                  <a (click)="openPulse()" matTooltip="Open the ETH Pulse support desk"><i
                      class="fa-solid fa-wave-square"></i> Pulse</a>
                </li>
                }
                @if(supportLink){
                <li>
                  <a routerLink="/support"
                    [matTooltip]="supportNeedsReply ? supportNeedsReply + ' conversation(s) waiting on your reply' : 'Your support conversations'"><i
                      class="fa-regular fa-comment-dots"></i> Support
                    @if(supportNeedsReply){<span class="badge bg-danger ms-1">{{ supportNeedsReply }}</span>}</a>
                </li>
                }

                <li>
                  <a (click)="logout()"><i class="fa-solid fa-arrow-right-from-bracket"></i>
                    Logout</a>
                </li>
              </ul>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="inner-nav nav-duplicate">
    <div class="container">
      <div class="mob-nav-head">
        <div class="row">
          <div class="col-2">
            <div class="nav-btn" (click)="mobileIconView = !mobileIconView">
              <img src="{{ imageUrl + 'assets/images/icons/hamburger-menu.svg' }}" height="30" />
            </div>
          </div>
          <div class="col-10">
            <div class="m-head-nav">
              <a href="#">Support </a> <span class="devider">|</span>
              <strong>Cash Bal: {{ avalBal ? avalBal : "∞" }}</strong>
              <span class="devider">|</span>
              <a routerLink="/recharge">Recharge</a>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-menu" [ngClass]="{ 'd-block': mobileIconView }">
        <div class="m-close-btn" (click)="mobileIconView = !mobileIconView">
          <img src="{{ imageUrl + 'assets/images/flight/close.svg' }}" height="20" />
        </div>
        <ul>
          @for (item of menuItems; track $index) {
          <li class="submenu-link li-list" [ngClass]="{ 'submenu-link': hasItems(item) }"
            [class.d-lg-none]="isManageItem(item)" [class.has-caret]="hasItems(item)"
            [class.is-active]="activeButton == item.label" [class.is-open]="$index === index">
            <a class="pop-up active-link" (click)="openProduct($event, $index, item)" [ngClass]="{
                active: activeButton == item.label,
                'submenu-link': hasItems(item)
              }" [routerLink]="item.link" role="button">

              <i class="{{ item.icon }}" *ngIf="item?.icon"></i>
              {{ item.label }}
            </a>
            <!-- desktop: the arrow alone opens the sub-menu -->
            @if(hasItems(item)){
            <button type="button" class="nav-caret d-none d-lg-inline-flex" (click)="toggleProductMenu($event, $index)"
              [attr.aria-expanded]="$index === index" [attr.aria-label]="'Open ' + item.label + ' menu'">
              <span class="nav-caret__chev" aria-hidden="true"></span>
            </button>
            }
            @if(hasItems(item)){
            <div class="dropdown-menu dropdown" #dropdown [ngClass]="{
                'dropdown-mega-menu-xl px-2': item.subItems.length > 14,
                show: $index === index
              }" aria-labelledby="topnav-dashboard">
              @for(subitem of item.subItems;track $index){
              @if(item.subItems.length < 15 && !hasItems(subitem)) { <a class="col dropdown-item side-nav-link-ref"
                [routerLink]="subitem.link" href="javascript: void(0);" routerLinkActive="active">


                <i class="{{ subitem.icon }}" *ngIf="subitem?.icon"></i>
                {{ subitem.label }}
                 </a>} @if(item.subItems.length > 15){
                <div>
                  @if($index % 3 == 0){
                  <div class="row">
                    <div class="col-lg-4">
                      <a class="dropdown-item side-nav-link-ref" routerLinkActive="active" [routerLink]="subitem.link">

                        <i class="{{ item.subItems[$index]?.icon }}" *ngIf="item.subItems[$index]?.icon"></i>
                        {{ item.subItems[$index].label }}
                      </a>
                    </div>
                    <div class="col-lg-4">
                      <a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                        [routerLink]="item.subItems[$index + 1]?.link">
                        <i class="{{ item.subItems[$index + 1]?.icon }}" *ngIf="item.subItems[$index + 1]?.icon"></i>
                        {{ item.subItems[$index + 1]?.label }}
                      </a>
                    </div>
                    <div class="col-lg-4">
                      <a class="dropdown-item side-nav-link-ref" routerLinkActive="active"
                        [routerLink]="item.subItems[$index + 2]?.link">
                        <i class="{{ item.subItems[$index + 2]?.icon }}" *ngIf="item.subItems[$index + 2]?.icon"></i>
                        {{ item.subItems[$index + 2]?.label }}
                      </a>
                    </div>
                  </div>
                  }
                </div>
                } @if(hasItems(subitem)){
                <div class="dropdown" (mouseenter)="keepSubmenuOnScreen($event)">
                  <a class="dropdown-item" href="javascript: void(0);" (click)="onSubMenu($event, $index)">


                    <i class="{{ subitem.icon }}" *ngIf="subitem?.icon"></i>
                    {{ subitem.label }}
                    <div class="arrow-down"></div>
                  </a>
                  <div class="dropdown-menu" [ngClass]="{ show: $index === subIndex }">

                    <ng-template ngFor let-subSubitem [ngForOf]="subitem.subItems">
                      @if(!hasItems(subSubitem) && subSubitem?.subItems ==
                      undefined ){
                      <a class="dropdown-item side-nav-link-ref" [routerLink]="subSubitem.link"
                        routerLinkActive="active">

                        <i class="{{ subSubitem.icon }}" *ngIf="subSubitem?.icon"></i>
                        {{ subSubitem.label }}
                      </a>
                      }
                      <ng-container *ngIf="hasItems(subSubitem) && subSubitem.subItems">
                        <div class="dropdown d-flex">
                          <a class="dropdown-item side-nav-link-ref" [routerLink]="subSubitem.link"
                            routerLinkActive="active" (click)="onSubMenuClick($event)">
                            <i class="{{ subSubitem.icon }}" *ngIf="subSubitem?.icon"></i>
                            {{ subSubitem.label }}
                          </a>
                          <div class="arrow-down"></div>
                        </div>
                        <div class="dropdown-menu side side-nav-link-ref" #subMenu>
                          <ng-template ngFor let-subSubitems [ngForOf]="subSubitem.subItems">
                            <a class="dropdown-item side-nav-link-ref" [routerLink]="subSubitems.link"
                              routerLinkActive="active">
                              <i class="{{ subSubitems.icon }}" *ngIf="subSubitems?.icon"></i>
                              {{ subSubitems.label }}
                            </a>
                          </ng-template>
                        </div>
                      </ng-container>
                    </ng-template>
                  </div>
                </div>
                } }
            </div>
            }
          </li>
          }

          <!-- desktop: back-office menus grouped behind "Manage" -->
          @if(manageItems.length){
          <li class="nav-manage d-none d-lg-block" [class.is-open]="manageOpen">
            <a class="pop-up active-link nav-manage__btn" [class.active]="isManageActive" role="button"
              aria-haspopup="true" [attr.aria-expanded]="manageOpen" (click)="toggleManage($event)">
              <i class="fa-solid fa-sliders"></i>
              Manage
              <span class="nav-manage__chev" aria-hidden="true"></span>
            </a>
            <div class="nav-manage__panel hub" role="dialog" aria-label="Manage" (click)="$event.stopPropagation()">
              <!-- search + quick access -->
              <div class="hub__top">
                <div class="hub__search">
                  <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
                  <input #hubSearchInput type="search" placeholder="Search Manage…" aria-label="Search Manage"
                    autocomplete="off" [value]="hubQuery" (input)="onHubSearch($any($event.target).value)"
                    (keydown.enter)="onHubSearchEnter()" />
                </div>
                @if(hubQuickLinks.length){
                <span class="hub__quick-label">Quick access</span>
                <div class="hub__quick">
                  @for(q of hubQuickLinks; track q.link){
                  <a class="hub__chip" [routerLink]="q.link" (click)="closeManage()">
                    <i class="{{ q.icon }}" *ngIf="q.icon"></i>{{ q.label }}
                  </a>
                  }
                </div>
                }
              </div>

              <div class="hub__body">
                <!-- section tabs -->
                <div class="hub__tabs" role="tablist">
                  @for(section of hubSections; track section.label; let i = $index){
                  <button type="button" class="hub__tab" role="tab" [class.is-active]="i === hubTab && !hubQuery"
                    [attr.aria-selected]="i === hubTab" (click)="hubTab = i; onHubSearch('')"
                    (mouseenter)="!hubQuery && (hubTab = i)">
                    <span class="hub__tab-icon"><i class="{{ section.icon }}"></i></span>
                    <span class="hub__tab-text">
                      <span class="hub__tab-label">{{ section.label }}</span>
                      <span class="hub__tab-sub">{{ section.subtitle }}</span>
                    </span>
                    <span class="hub__count">{{ section.count }}</span>
                  </button>
                  }
                </div>

                <!-- pages of the selected section, or search results -->
                <div class="hub__content">
                  @if(hubQuery){
                  <div class="hub__heading">Results for “{{ hubQuery }}”</div>
                  @if(hubResults.length){
                  <div class="hub__grid">
                    @for(r of hubResults; track r.link){
                    <a class="hub__item" [routerLink]="r.link" routerLinkActive="is-current" (click)="closeManage()">
                      <span class="hub__item-icon"><i class="{{ r.icon || 'fa-regular fa-file' }}"></i></span>
                      <span class="hub__item-text">
                        <span class="hub__item-label">{{ r.label }}</span>
                        <span class="hub__item-path">{{ r.path }}</span>
                      </span>
                    </a>
                    }
                  </div>
                  } @else {
                  <div class="hub__empty">Nothing under Manage matches “{{ hubQuery }}”.</div>
                  }
                  } @else {
                  @if(hubSections[hubTab]; as section){
                  <div class="hub__heading">{{ section.label }}</div>
                  <div class="hub__grid">
                    @for(entry of section.entries; track entry.label){
                    @if(entry.children.length){
                    <div class="hub__item hub__item--group">
                      <span class="hub__item-icon"><i class="{{ entry.icon || 'fa-regular fa-folder' }}"></i></span>
                      <span class="hub__item-text">
                        <span class="hub__item-label">{{ entry.label }}</span>
                        <span class="hub__children">
                          @for(child of entry.children; track child.link){
                          <a class="hub__child" [routerLink]="child.link" routerLinkActive="is-current"
                            (click)="closeManage()">{{ child.label }}</a>
                          }
                        </span>
                      </span>
                    </div>
                    } @else if(entry.link){
                    <a class="hub__item" [routerLink]="entry.link" routerLinkActive="is-current" (click)="closeManage()">
                      <span class="hub__item-icon"><i class="{{ entry.icon || 'fa-regular fa-file' }}"></i></span>
                      <span class="hub__item-text">
                        <span class="hub__item-label">{{ entry.label }}</span>
                      </span>
                    </a>
                    }
                    }
                  </div>
                  }
                  }
                </div>
              </div>
            </div>
          </li>
          }
        </ul>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</section>